import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
export const headerContainer: SxProps<Theme> = {
  position: 'relative'
};
export const headerStyles = (isOnForms: boolean): SxProps<Theme> => ({
  width: '100%',
  height: '5.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: isOnForms ? 'space-between' : 'center',
  padding: '1.5rem',
  backgroundColor: 'backgrounds.dark'
});
export const headerSpacer: SxProps<Theme> = {
  width: '18rem',
  display: 'flex',
  justifyContent: 'flex-start'
};
export const formsHeaderActions = (isLargeDevice: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: isLargeDevice ? '1rem' : '0.5rem',
  width: isLargeDevice ? '18rem' : 'auto'
});
export const mobileHeaderStyles: SxProps<Theme> = {
  width: '100%',
  height: '4rem',
  padding: '0.5rem 0.75rem',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  backgroundColor: 'backgrounds.dark'
};
export const hamburgerStyles: SxProps<Theme> = {
  position: 'absolute',
  left: '0'
};
export const desktopLogoContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center'
};
export const mobileLogoContainer = (isOnForms: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  // 'center'
  paddingLeft: '0.75rem',
  // remove
  gap: '0.75rem',
  flex: isOnForms ? '1 0 0' : '0'
});
export const mobileLogo: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
export const signoutButton = (isLargeDevice: boolean): SxProps<Theme> => ({
  width: '12.5rem',
  display: 'inline-flex',
  justifyContent: isLargeDevice ? 'center' : 'flex-end',
  alignItems: 'center',
  gap: 'var(--Grid-4, 0.25rem)',
  textTransform: 'none',
  color: 'white'
});
export const logoutIcon = {
  width: '1.5rem',
  height: '1.5rem'
};